var React = require('react');

function ChevronDownInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.702 4.8l1.426 1.401-5.415 5.514a1 1 0 0 1-1.426 0L1.872 6.2l1.426-1.4L8 9.587 12.702 4.8z","fill":"currentColor"}));
}

ChevronDownInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = ChevronDownInline;

ChevronDownInline.default = ChevronDownInline;
